"use client";

import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Pagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const BusinessType = () => {
  // Fields for create modal
  const [createForm, setCreateForm] = useState({
    businessId: "",
    firstName: "",
    lastName: "",
    mobileNo: "",
    emailId: "",
    businessName: "",
    category: "",
    subCategory: "",
    address: "",
    terms: false,
    idProof: "",
    residentialProof: "",
    status: false,
  });
  const [createLoading, setCreateLoading] = useState(false);
  const [createError, setCreateError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [categories, setCategories] = useState([]); // Business Categories (e.g., Education, Healthcare, Retail)
  const [subCategories, setSubCategories] = useState([]); // Subcategories from Subcategory collection
  //console.log("Business Types:", businessTypes);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [editCategoryName, setEditCategoryName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editStatus, setEditStatus] = useState(true);
  const [openCreateModal, setOpenCreateModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch all admin/business records
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/getalladmin`,
        );
        const data = await response.json();
        setBusinessTypes(data);

        // Fetch Business Categories (main categories like Education, Healthcare, Retail)
        const categoriesResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/getall-category`,
        );
        const categoriesData = await categoriesResponse.json();
        setCategories(categoriesData);

        // Fetch Subcategories from Subcategory collection
        const subCategoriesResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/subcategory/getall-subcategory`,
        );
        const subCategoriesData = await subCategoriesResponse.json();
        setSubCategories(subCategoriesData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
    setCurrentPage(1);
  };

  const filteredData = businessTypes.filter((item) => {
    const search = searchQuery.toLowerCase();
    return (
      item.businessId?.toLowerCase().includes(search) ||
      item.businessName?.toLowerCase().includes(search) ||
      item.firstName?.toLowerCase().includes(search) ||
      item.lastName?.toLowerCase().includes(search) ||
      item.emailId?.toLowerCase().includes(search) ||
      item.mobileNo?.toLowerCase().includes(search) ||
      item.category?.toLowerCase().includes(search) ||
      item.subCategory?.toLowerCase().includes(search)
    );
  });

  //console.log("Filtered Data:", filteredData);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handleEditClick = (item) => {
    setSelectedBusinessType(item);
    setEditCategoryName(item.category_name || "");
    setEditDescription(item.description || "");
    setEditStatus(item.status);
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this business type?")) {
      await fetch(`/api/save-category`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ _id: id }),
      });

      const res = await fetch("/api/save-category");
      const data = await res.json();
      setBusinessTypes(data);
    }
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
          flexWrap="wrap"
          gap={2}
        >
          <TextField
            label="Search"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{ height: "40px" }}
            onClick={() => setOpenCreateModal(true)}
          >
            Add New Business
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Business ID</TableCell>
                <TableCell>Business Name</TableCell>
                <TableCell>Owner Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Sub Category</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>Status</TableCell>
                {/* <TableCell>Action</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="bold">
                        {item.businessId || `BUS-${item._id?.slice(-4)}`}
                      </Typography>
                    </TableCell>
                    <TableCell>{item.businessName}</TableCell>
                    <TableCell>
                      {item.firstName} {item.lastName}
                    </TableCell>
                    <TableCell>{item.emailId}</TableCell>
                    <TableCell>{item.mobileNo}</TableCell>
                    <TableCell>{item.category}</TableCell>
                    <TableCell>{item.subCategory}</TableCell>
                    <TableCell>
                      {item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString()
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        color={item.status ? "success.main" : "error.main"}
                      >
                        {item.status ? "Active" : "Inactive"}
                      </Typography>
                    </TableCell>
                    {/* <TableCell>
                      <Button
                        onClick={() => handleEditClick(item)}
                        size="small"
                        color="primary"
                      >
                        Edit
                      </Button>
                      <Button
                        onClick={() => handleDelete(item._id)}
                        size="small"
                        color="error"
                      >
                        Delete
                      </Button>
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No business types found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Typography variant="body2">
            Showing {paginatedData.length} of {filteredData.length} items
          </Typography>
          {totalPages > 1 && (
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(_, page) => setCurrentPage(page)}
              color="primary"
            />
          )}
        </Box>

        <Dialog open={showEditModal} onClose={() => setShowEditModal(false)}>
          <DialogTitle>Edit Business Type</DialogTitle>
          <DialogContent>
            <Box mt={2}>
              <TextField
                label="Category Name"
                fullWidth
                value={editCategoryName}
                onChange={(e) => setEditCategoryName(e.target.value)}
                margin="normal"
              />
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={editDescription}
                onChange={(e) => setEditDescription(e.target.value)}
                margin="normal"
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Status</InputLabel>
                <Select
                  value={editStatus ? "active" : "inactive"}
                  onChange={(e) => setEditStatus(e.target.value === "active")}
                  label="Status"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowEditModal(false)}>Cancel</Button>
            <Button
              onClick={async () => {
                await fetch(`/api/save-category`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    category_name: editCategoryName,
                    description: editDescription,
                    status: editStatus,
                    _id: selectedBusinessType._id,
                  }),
                });
                setShowEditModal(false);
              }}
              variant="contained"
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>

        {/* Create New Business Modal */}
        <Dialog
          open={openCreateModal}
          onClose={() => setOpenCreateModal(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Add New Business</DialogTitle>
          <DialogContent>
            <Box mt={2}>
              <TextField
                label="Business ID"
                fullWidth
                margin="normal"
                value={createForm.businessId}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, businessId: e.target.value }))
                }
                placeholder="Auto-generated if left empty"
                helperText="Unique Business ID (e.g., BUS-0001)"
              />
              <TextField
                label="First Name"
                fullWidth
                margin="normal"
                value={createForm.firstName}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, firstName: e.target.value }))
                }
              />
              <TextField
                label="Last Name"
                fullWidth
                margin="normal"
                value={createForm.lastName}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, lastName: e.target.value }))
                }
              />
              <TextField
                label="Mobile No"
                fullWidth
                margin="normal"
                value={createForm.mobileNo}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, mobileNo: e.target.value }))
                }
              />
              <TextField
                label="Email"
                fullWidth
                margin="normal"
                value={createForm.emailId}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, emailId: e.target.value }))
                }
              />
              <TextField
                label="Business Name"
                fullWidth
                margin="normal"
                value={createForm.businessName}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, businessName: e.target.value }))
                }
              />
              {/* Category: Main business sector (e.g., Education, Healthcare, Retail, Food & Beverage) */}
              <FormControl fullWidth margin="normal">
                <InputLabel>Category *</InputLabel>
                <Select
                  value={createForm.category}
                  onChange={(e) =>
                    setCreateForm((f) => ({ ...f, category: e.target.value }))
                  }
                  label="Category *"
                >
                  <MenuItem value="" disabled>
                    Select business category
                  </MenuItem>
                  {categories.map((cat) => (
                    <MenuItem key={cat._id} value={cat.category_name}>
                      {cat.category_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* Subcategory: Specific business subcategory within the selected category */}
              <FormControl fullWidth margin="normal">
                <InputLabel>Sub Category *</InputLabel>
                <Select
                  value={createForm.subCategory}
                  onChange={(e) =>
                    setCreateForm((f) => ({
                      ...f,
                      subCategory: e.target.value,
                    }))
                  }
                  label="Sub Category *"
                >
                  <MenuItem value="" disabled>
                    Select subcategory
                  </MenuItem>
                  {subCategories.map((subCat) => (
                    <MenuItem key={subCat._id} value={subCat.subcategory_name}>
                      {subCat.subcategory_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Address"
                fullWidth
                margin="normal"
                value={createForm.address}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, address: e.target.value }))
                }
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Terms Accepted</InputLabel>
                <Select
                  value={createForm.terms ? "yes" : "no"}
                  onChange={(e) =>
                    setCreateForm((f) => ({
                      ...f,
                      terms: e.target.value === "yes",
                    }))
                  }
                  label="Terms Accepted"
                >
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="ID Proof"
                fullWidth
                margin="normal"
                value={createForm.idProof}
                onChange={(e) =>
                  setCreateForm((f) => ({ ...f, idProof: e.target.value }))
                }
              />
              <TextField
                label="Residential Proof"
                fullWidth
                margin="normal"
                value={createForm.residentialProof}
                onChange={(e) =>
                  setCreateForm((f) => ({
                    ...f,
                    residentialProof: e.target.value,
                  }))
                }
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Status</InputLabel>
                <Select
                  value={createForm.status ? "active" : "inactive"}
                  onChange={(e) =>
                    setCreateForm((f) => ({
                      ...f,
                      status: e.target.value === "active",
                    }))
                  }
                  label="Status"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
              {createError && (
                <Typography color="error" mt={2}>
                  {createError}
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenCreateModal(false)}
              disabled={createLoading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={createLoading}
              onClick={async () => {
                setCreateLoading(true);
                setCreateError("");
                try {
                  // Generate Business ID if not provided
                  const businessIdToUse =
                    createForm.businessId ||
                    `BUS-${String(businessTypes.length + 1).padStart(4, "0")}`;

                  const dataToSubmit = {
                    ...createForm,
                    businessId: businessIdToUse,
                  };

                  const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/admin/createadmin`,
                    {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(dataToSubmit),
                    },
                  );
                  if (!response.ok) {
                    const err = await response.json();
                    setCreateError(err.message || "Failed to create business");
                  } else {
                    setOpenCreateModal(false);
                    setCreateForm({
                      businessId: "",
                      firstName: "",
                      lastName: "",
                      mobileNo: "",
                      emailId: "",
                      businessName: "",
                      category: "",
                      subCategory: "",
                      address: "",
                      terms: false,
                      idProof: "",
                      residentialProof: "",
                      status: false,
                    });
                    // Refresh the entire list
                    const refreshResponse = await fetch(
                      `${process.env.REACT_APP_API_URL}/api/admin/getalladmin`,
                    );
                    const refreshedData = await refreshResponse.json();
                    setBusinessTypes(refreshedData);
                  }
                } catch (e) {
                  setCreateError("Network error");
                }
                setCreateLoading(false);
              }}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default BusinessType;
